import { ShoppingCart, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useFinancialWidgets } from '@/hooks/use-financial-widgets';
import { Card, CardContent } from '@/components/ui/card';

export function KpiAcquisitionCost() {
  const { useFinancialSummary } = useFinancialWidgets();
  const { data, isLoading } = useFinancialSummary();

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Acquisition Cost"
      value={data ? formatCurrency(data.totalPurchasePrice) : '—'}
      changeLabel="Total original purchase value"
      icon={ShoppingCart}
      variant="info"
    />
  );
}
